import BaseComponent from '@bahn-wordpress/common/src/js/blocks/base-component'
import {isElementInViewport} from '@bahn-wordpress/common/src/js/utils/in-viewport'
import {getMediaQueryByWidth} from '@bahn-wordpress/common/src/js/utils/media-query-helper'
import * as screenSizes from '@bahn-wordpress/common/src/js/utils/screen-sizes'

// const TYPE_SINGLE = 'single'
// const DEFAULT_TYPE = TYPE_SINGLE
// const SCROLL_OFFSET = -83.5
// const IS_MOBILE = (window.innerWidth < '600')

export default class TextImageTeaserAnimated extends BaseComponent {
    constructor(...args){
        super(...args)

        this.actualMediaQuery = null

        if(this.element) {
            this.init()
        }
    }

    init(){
        this.updateActualMediaQuery()
        this.addScrollListener()
    }

    updateActualMediaQuery(){
        this.actualMediaQuery = getMediaQueryByWidth(window.innerWidth)
    }

    getThreshold(){
        return this.actualMediaQuery === screenSizes.small ? 0.4 : 0.85
    }

    async addScrollListener(){
        await isElementInViewport(this.element, this.getThreshold())
        this.fadeIn()
    }

    fadeIn(){
        this.element.classList.add('text-image-teaser--show')
    }
}
